import { useSetAtom } from "jotai";
import { useCallback, useState } from "react";
import type { FunctionComponent } from "react";

import { useResponsive } from "shared/hooks";
import { theme } from "shared/lib/styles";

import { myNewsAtom } from "scmp-app/lib/mynews/atoms";

import {
  Container,
  Description,
  IconInfo,
  IconInfoContainer,
  IndicatorWrapper,
  LogoMynews,
  StyledIndicator,
  Wrapper,
} from "./styles";

export type Props = {
  className?: string;
  isShowIndicatorIcon?: boolean;
};

export const MynewsHeader: FunctionComponent<Props> = ({
  className,
  isShowIndicatorIcon = false,
}) => {
  const [isShowIndicator, setIsShowIndicator] = useState(false);
  const setMynewsState = useSetAtom(myNewsAtom);

  const isTabletUp = useResponsive(theme.breakpoints.up("tablet"), false);
  const isMobile = useResponsive(theme.breakpoints.only("mobile"), false);

  const onShowIndicatorCardClick = useCallback(() => {
    if (isTabletUp && isShowIndicator) {
      setMynewsState({ isShowIndicatorCard: false });
    }
    if (isMobile) {
      setMynewsState({ isShowIndicatorCard: true });
    }
  }, [setMynewsState, isTabletUp, isShowIndicator, isMobile]);

  return (
    <Container className={className}>
      <Wrapper>
        <LogoMynews />
        {isShowIndicatorIcon && (
          <IconInfoContainer
            onClick={onShowIndicatorCardClick}
            onMouseLeave={() => setIsShowIndicator(false)}
            onMouseOver={() => setIsShowIndicator(true)}
          >
            <IconInfo />
          </IconInfoContainer>
        )}
        <IndicatorWrapper
          onMouseLeave={() => setIsShowIndicator(false)}
          onMouseOver={() => setIsShowIndicator(true)}
        >
          <StyledIndicator isShow={isShowIndicator} />
        </IndicatorWrapper>
      </Wrapper>
      <Description>The stories that matter to you.</Description>
    </Container>
  );
};

MynewsHeader.displayName = "MynewsHeader";
